import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';
import { ANIM_SPEED_MS, akEditorSwoopCubicBezier } from './TemplatesSidebar';

export const actionButton = (expanded: boolean) => css`
  position: absolute;
  top: 83px;
  right: ${expanded ? '300px' : '17px'};
  cursor: pointer;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: ${token('color.text')};
  transition: right ${ANIM_SPEED_MS}ms ${akEditorSwoopCubicBezier};
  background-color: ${!expanded && 'white'};

  &:hover {
    background-color: ${token('color.background.accent.gray.subtlest.hovered')};
  }

  &:active {
    background-color: ${token('color.background.accent.gray.subtlest.pressed')};
`;

export const plainButton = css`
  cursor: pointer;
  background: none;
  border: none;
  border-radius: 4px;
  color: ${token('color.text')};

  &:hover {
    background-color: ${token('color.background.accent.gray.subtlest')};
  }

  &:active {
    background-color: ${token('color.background.neutral.pressed')};
  }
`;
